export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  readingTime: number;
}

export const articlesData: Article[] = [
  {
    id: 1,
    slug: 'devops-devsecops',
    title: 'Le métier du DevOps & DevSecOps',
    excerpt: 'Culture DevOps, CI/CD, Infrastructure as Code, GitOps — et comment intégrer la sécurité dès la conception avec le DevSecOps et le principe Shift Left.',
    content: '',
    readingTime: 4,
  },
  {
    id: 4,
    slug: 'monitoring',
    title: "L'importance du Monitoring en infrastructure",
    excerpt: 'Les 4 signaux dorés, Prometheus & Grafana, Zabbix, SIEM et XDR — construire une stack de supervision complète pour anticiper les incidents.',
    content: '',
    readingTime: 4,
  },
  {
    id: 5,
    slug: 'ai-security',
    title: 'Sécurité et IA : les bonnes pratiques',
    excerpt: "Prompt injection, fuite de données, data poisoning, sécurisation des APIs IA — les risques spécifiques aux LLMs et comment s'en protéger.",
    content: '',
    readingTime: 5,
  },
  {
    id: 6,
    slug: 'backup-pra-prs',
    title: 'Sauvegardes, PRA & PRS : pourquoi tester ses backups vous sauve',
    excerpt: "Règle 3-2-1, RPO/RTO, Plan de Reprise d'Activité et de Service — et pourquoi tester régulièrement ses sauvegardes est la seule vraie garantie de continuité.",
    content: '',
    readingTime: 5,
  },
];
